module.exports = __webpack_public_path__ + "static/img/4.9f25de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/4.png
// module id = 9Jcd
// module chunks = 0